import { Navigate, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useInitiateMailchimp } from '../../../apiHooks/mutations/integrationMutations/mailchimpMutation';

const MailchimpRoute = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeParam = queryParams.get('code');
  const { mutate: initiate } = useInitiateMailchimp();

  useEffect(() => {
    if (codeParam) {
      initiate(codeParam);
    }
  }, []);

  return <Navigate to="/dashboard" />;
};

export default MailchimpRoute;
